module.exports = __webpack_public_path__ + "media/lobby_selfintro.7d5f07e0.mp3";